import { RouteRecordRaw } from 'vue-router';
import { LazyComponent } from '@/models/LazyComponent';
import { invalidateVueQueryCache } from '@/plugins/vueQuery';
import { sessionService } from '@/services';

const AutenticacaoView: LazyComponent = () => import(/* webpackChunkName: "deeplink-captacao-autenticacao" */ './views/AutenticacaoView.vue');
const DeeplinkView: LazyComponent = () => import(/* webpackChunkName: "deeplink-view" */ '@/views/deeplink-view.vue');

export const routes: RouteRecordRaw[] = [
  {
    path: '/deeplink-captacao/autenticacao',
    component: DeeplinkView,
    meta: { allowAnonymous: true, disableNavigation: true },
    beforeEnter() {
      invalidateVueQueryCache();
      sessionService.logout('deeplink_captacao_autenticacao');
    },
  },
  {
    path: '/deeplink-captacao/autenticacao/login',
    name: 'deeplink-captacao-autenticacao',
    component: AutenticacaoView,
    meta: { allowAnonymous: true },
    beforeEnter() {
      invalidateVueQueryCache();
      sessionService.logout('deeplink_captacao_autenticacao_login');
    },
  },
];

export default routes;
